export const isPlaceholderString = (value: string | undefined) => {
   if (!value) return false;
   const regex = /\[%s:([^%]+)]/g;
   return regex.test(value);
};
